import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TopBlockAdmin from '../AdminContainer/TopBlock';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';

interface TopBlockProps {
    reloadList: () => void;
    permissionCreate: boolean;
    handleExport: (type: ExportTypeType) => void;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    return (
        <>
            <TopBlockAdmin />
            <BodyTopBlock
                actions={[
                    {
                        node: (
                            <ExportTableAction
                                title={translate('egonRoutes.action.exportFile')}
                                handleExport={props.handleExport}
                            />
                        ),
                    },
                    {
                        onClick: props.reloadList,
                        icon: <ReloadIcon />,
                        tooltip: translate('egonRoutes.action.synchronizeTable'),
                        variant: 'outlined',
                    },
                    {
                        label: translate('egonRoutes.action.createNew'),
                        onClick: () => navigate('/admin/egon-routes/new'),
                        icon: <AddIcon />,
                        hidden: !props.permissionCreate,
                        'data-testid': 'egon-routes-create',
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
